export const PERMISSION_RESOURCE_CODES = {
  permission: 'permission',
  questionCenterHome: 'question-center-home',
  questionCenterTopics: 'question-center-topics',
  questionCenterTopicDetail: 'question-center-topic-detail',
  questionCenterQuestionList: 'question-center-question-list',
  questionCenterQuestionDetail: 'question-center-question-detail',
  questionCenterAsk: 'question-center-ask',
  questionCenterFaq: 'question-center-faq',
  questionCenterMine: 'question-center-mine',
  questionCenterSettingsCategory: 'question-center-settings-category',
  questionCenterSettingsTag: 'question-center-settings-tag',
  questionCenterSettingsFaqFeatured: 'question-center-settings-faq-featured',
  questionCenterSettingsQuestion: 'question-center-settings-question',
  questionCenterSettingsAnswer: 'question-center-settings-answer',
  questionCenterSettingsTopic: 'question-center-settings-topic',
  questionCenterSettingsDeduplication: 'question-center-settings-deduplication',
  questionCenterSettingsDashboard: 'question-center-settings-dashboard',
} as const;

export const PERMISSION_ACTION_CODES = {
  permission: {},
  questionCenterHome: {
    query: 'query',
    create: 'create',
  },
  questionCenterTopics: {
    query: 'query',
    search: 'search',
  },
  questionCenterTopicDetail: {
    query: 'query',
    create: 'create',
  },
  questionCenterQuestionList: {
    query: 'query',
    search: 'search',
    filter: 'filter',
    create: 'create',
  },
  questionCenterQuestionDetail: {
    query: 'query',
    follow: 'follow',
    create: 'create',
    submit: 'submit',
    accept: 'accept',
  },
  questionCenterAsk: {
    query: 'query',
    filter: 'filter',
    upload: 'upload',
    submit: 'submit',
    reset: 'reset',
  },
  questionCenterFaq: {
    query: 'query',
    search: 'search',
    filter: 'filter',
  },
  questionCenterMine: {
    query: 'query',
  },
  questionCenterSettingsCategory: {
    query: 'query',
    create: 'create',
    edit: 'edit',
    delete: 'delete',
  },
  questionCenterSettingsTag: {
    query: 'query',
    create: 'create',
    edit: 'edit',
    delete: 'delete',
  },
  questionCenterSettingsFaqFeatured: {
    query: 'query',
    edit: 'edit',
  },
  questionCenterSettingsQuestion: {
    query: 'query',
    edit: 'edit',
    disable: 'disable',
  },
  questionCenterSettingsAnswer: {
    query: 'query',
    edit: 'edit',
    disable: 'disable',
  },
  questionCenterSettingsTopic: {
    query: 'query',
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    enable: 'enable',
    disable: 'disable',
    manage: 'manage',
  },
  questionCenterSettingsDeduplication: {
    query: 'query',
    search: 'search',
    merge: 'merge',
  },
  questionCenterSettingsDashboard: {
    query: 'query',
  },
} as const;

export type PermissionResourceCode =
  (typeof PERMISSION_RESOURCE_CODES)[keyof typeof PERMISSION_RESOURCE_CODES];

type PermissionActionCodeMap = typeof PERMISSION_ACTION_CODES;

export type PermissionActionCode =
  PermissionActionCodeMap[keyof PermissionActionCodeMap][keyof PermissionActionCodeMap[keyof PermissionActionCodeMap]];
